import { Routes } from '@angular/router';
import { authRoutes } from './core/login/auth.routes';
import { homePageRoutes } from './features/homepage/homepage.routes';
import { userRoutes } from './features/users/user.routes';
import { leadsRoutes } from '@features/leads/leads.routes';
import { followUpRoutes } from '@features/follow-up/follow-up.routes';
import { treasurerRoutes } from '@features/treasurer/treasurer.routes';
import { emittersRoutes } from '@features/emitters/emitters.routes';
import { quotaRoutes } from '@features/quota/quota.routes';
import { calcRoutes } from '@features/calculator/calculator.routes';
import { calcPrimeRoutes } from '@features/calculador-prime/calculator.prime.routes';
import { channelsRoutes } from '@features/channels/channels.routes';
import { addressesRoutes } from '@features/addresses/address.routes';
import { notificationsRoutes } from '@features/notifications/notifications.routes';
import { notificationsSendRoutes } from '@features/notifications-send/notifications-send.routes';
import { variableCatalogRoutes } from '@features/catalog-variables/variable-catalog.routes';
import { catalogAttributeRoutes } from '@features/catalog-attributes/catalog-attribute.routes';
import { transactionsRoutes } from '@features/transactions/transactions.routes';
import { fundsRoutes } from '@features/funds/funds.routes';
import { dividendsRoutes } from '@features/dividends/dividends.routes';
import { appDirectoryRoutes } from '@features/app-directory/app-directory.routes';
import { subaccountsRoutes } from '@features/subaccounts/subaccounts.routes';
import { accountStatementGenerationRoutes } from '@features/account-statement-generation/account-statement-generation.routes';

export const routes: Routes = [
  ...authRoutes,
  ...homePageRoutes,
  ...userRoutes,
  ...leadsRoutes,
  ...followUpRoutes,
  ...treasurerRoutes,
  ...emittersRoutes,
  ...quotaRoutes,
  ...calcRoutes,
  ...calcPrimeRoutes,
  ...channelsRoutes,
  ...addressesRoutes,
  ...notificationsRoutes,
  ...notificationsSendRoutes,
  ...variableCatalogRoutes,
  ...catalogAttributeRoutes,
  ...transactionsRoutes,
  ...fundsRoutes,
  ...dividendsRoutes,
  ...appDirectoryRoutes,
  ...subaccountsRoutes,
  ...accountStatementGenerationRoutes,
  {
    path: '',
    redirectTo: '/login',
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: '/login',
    pathMatch: 'full',
  },
];
